import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AccountTypeClient, AccountTypeView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class AccountTypeService {
    constructor(private readonly client: AccountTypeClient) {}

    async getAll(): Promise<AccountTypeView[]> {
        return await lastValueFrom(this.client.accountTypeGetAll());
    }
}
